export default __webpack_public_path__ + "static/media/community-art.4bb1249a.png";